import { Link } from 'react-router-dom';

const ImpactSection = () => {
  return (
    <section id="impact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Impact Stats */}
        <div className="text-center mb-24">
          <h2 className="font-poppins font-black text-5xl sm:text-6xl text-charcoal mb-6 leading-tight">
            Creating Real Change
          </h2>
          <div className="w-24 h-2 bg-primary mx-auto mb-12"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="bg-gradient-to-br from-primary to-primary/80 p-10 rounded-2xl text-white shadow-xl">
              <div className="font-poppins font-black text-6xl mb-3">100+</div>
              <div className="font-inter text-xl font-semibold">Latinas Mentored</div>
            </div>
            <div className="bg-gradient-to-br from-secondary to-secondary/80 p-10 rounded-2xl text-white shadow-xl">
              <div className="font-poppins font-black text-6xl mb-3">50+</div>
              <div className="font-inter text-xl font-semibold">Mentoring Connections</div>
            </div>
            <div className="bg-gradient-to-br from-electric to-electric/80 p-10 rounded-2xl text-white shadow-xl">
              <div className="font-poppins font-black text-6xl mb-3">6000+</div>
              <div className="font-inter text-xl font-semibold">Cafecito Mentoring Hours</div>
            </div>
          </div>
        </div>

        {/* MAS Academy */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="font-poppins font-black text-5xl sm:text-6xl text-charcoal leading-tight mb-6">
              MAS Academy The Evolution is Here
            </h2>
            <div className="w-24 h-2 bg-primary mb-8"></div>
            <p className="font-inter text-xl text-charcoal/80 mb-8 leading-relaxed">
              Empowering Latina leaders through transformative workshops designed to build skills, confidence, and career momentum. From executive presence to strategic delegation, our curriculum is built for the modern workplace.
            </p>
            <p className="font-inter text-lg text-charcoal/70 mb-10 leading-relaxed">
              <strong className="text-charcoal">Self-development should not have a cost of entry.</strong> All workshops are free for our community members.
            </p>
          </div>

          <div className="flex flex-col items-center justify-center gap-8">
            <img 
              src="https://static.readdy.ai/image/ddb3f6bea97a6774f2df2489e0165868/10accdafe3cc6066ca166d247598a98e.png"
              alt="MAS Academy Logo"
              className="w-full max-w-md h-auto"
            />
            <Link
              to="/mas-academy"
              className="inline-block bg-primary hover:bg-primary/90 text-white font-inter font-semibold px-8 py-4 rounded-lg transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
            >
              Explore Workshops
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;
